import React from 'react';
import './Pages.css';

function About({ onContactClick }) {
  const values = [
    { icon: '✦', title: 'Curated Selection', desc: 'Every design is handpicked for quality and aesthetics' },
    { icon: '◈', title: 'Trusted Sources', desc: 'Products from established manufacturers' },
    { icon: '▣', title: 'Wide Variety', desc: 'Options for every style and budget' },
    { icon: '✧', title: 'Expert Support', desc: 'Guidance for your project needs' },
  ];

  return (
    <div className="page about-page">
      {/* Hero Banner */}
      <div className="page-hero">
        <div className="page-hero-bg about-bg"></div>
        <div className="page-hero-content">
          <h1>About Crunch</h1>
          <p>Your trusted partner in decorative laminates</p>
        </div>
      </div>

      <div className="page-container">
        <section className="about-section fade-in">
          <h2>Who We Are</h2>
          <p>
            Crunch is a trusted name in the decorative laminates industry, 
            dedicated to bringing carefully curated designs to homes, offices, and 
            commercial spaces across India. We believe that every space deserves 
            surfaces that reflect quality, aesthetics, and attention to detail.
          </p>
        </section>

        <section className="about-section fade-in">
          <h2>Our Approach to Design</h2>
          <p>
            Every design in our collection is thoughtfully selected to meet the 
            diverse needs of modern interiors. From timeless wood grain patterns to 
            contemporary solid colors, our range is curated to offer options that 
            complement various design sensibilities and architectural styles.
          </p>
          <p>
            We work closely with designers and manufacturers to ensure that each 
            laminate in our catalog represents a balance of visual appeal and 
            practical functionality.
          </p>
        </section>

        {/* Values Grid */}
        <section className="values-section fade-in">
          <h2>Why Choose Crunch</h2>
          <div className="values-grid">
            {values.map((value, index) => (
              <div key={index} className="value-card">
                <span className="value-icon">{value.icon}</span>
                <h3>{value.title}</h3>
                <p>{value.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="about-section fade-in">
          <h2>Quality You Can Trust</h2>
          <p>
            At Crunch, we prioritize sourcing from established manufacturers 
            who follow industry-standard production processes. Our laminates are 
            selected based on their finish, durability characteristics, and suitability 
            for various applications including furniture, cabinetry, wall panels, and 
            interior surfaces.
          </p>
        </section>

        <section className="about-section fade-in">
          <h2>Our Product Range</h2>
          <p>
            We offer a comprehensive selection of decorative laminates to suit 
            different project requirements:
          </p>
          <ul className="about-list">
            <li>
              <strong>Wood Grain Laminates</strong> – Natural textures inspired by 
              oak, walnut, teak, and other popular wood species
            </li>
            <li>
              <strong>Solid Color Laminates</strong> – Clean, vibrant finishes for 
              modern and minimalist designs
            </li>
            <li>
              <strong>Stone & Marble Patterns</strong> – Elegant designs that bring 
              sophistication to any surface
            </li>
            <li>
              <strong>Abstract & Textured Finishes</strong> – Unique patterns for 
              distinctive interior statements
            </li>
            <li>
              <strong>Metallic Laminates</strong> – Contemporary finishes for 
              commercial and residential applications
            </li>
          </ul>
        </section>

        <section className="about-section fade-in">
          <h2>Our Commitment</h2>
          <p>
            We are committed to helping our customers find the right laminate 
            solutions for their projects. Whether you are an architect, interior 
            designer, contractor, or homeowner, our team is here to assist you 
            in selecting products that align with your vision and requirements.
          </p>
          <p>
            At Crunch, we believe that good design should be accessible. 
            That's why we strive to offer a diverse range of options at various 
            price points, ensuring that quality decorative surfaces are within 
            reach for every project.
          </p>
        </section>

        <section className="about-cta-section fade-in">
          <div className="about-cta-card">
            <h2>Get in Touch</h2>
            <p>
              Have questions about our products or need assistance with your project? 
              We'd love to hear from you.
            </p>
            <button className="cta-btn" onClick={onContactClick}>
              Contact Us
            </button>
          </div>
        </section>
      </div>
    </div>
  );
}

export default About;
